import { systemThemeChangeHandler } from './systemThemeChangeHandler';

export const monitorSystemThemeChanges = (): void => {
    const darkModeQuery = window.matchMedia?.('(prefers-color-scheme: dark)');

    if (darkModeQuery.addEventListener) {
        darkModeQuery.addEventListener('change', systemThemeChangeHandler);
    } else {
        darkModeQuery.addListener(systemThemeChangeHandler);
    }
};
